import { render, staticRenderFns } from "./LocationSysAdminNotifications.vue?vue&type=template&id=58005c71&scoped=true&"
import script from "./LocationSysAdminNotifications.vue?vue&type=script&lang=js&"
export * from "./LocationSysAdminNotifications.vue?vue&type=script&lang=js&"
import style0 from "./LocationSysAdminNotifications.vue?vue&type=style&index=0&id=58005c71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58005c71",
  null
  
)

export default component.exports